/**
 * Created by fernando.garcia on 1/08/19.
 */

/**
 * Devuelve una regla de una lista de reglas
 * Ejemplo de regla devuelta: {"name":"cookie","operator":"equal","values":["1"],"parameters":[{"name":"ee"}]}]}
 *
 * @param ruleName Nombre de la regla
 * @param rulesList Lista de reglas
 * @returns {string}
 */
const getRule = function (ruleName, rulesList) {
    if (rulesList !== undefined) {
        let parsedRules = JSON.parse(rulesList).rules;
        for (let key in parsedRules) {
            for (let prop in parsedRules[key]) {
                if (prop == 'name' && parsedRules[key][prop] == ruleName) {
                    return parsedRules[key];
                }
            }
        }
    }
    return '';
}

/**
 * Devuelve el valor de una propiedad de una regla de una lista de reglas
 * Para una lista de reglas así:
 * [
 *  {"name":"cookie","operator":"equal","values":["1"],"parameters":[{"name":"ee"}]}]},
 *  {"name":"main_type","operator":"in","values":["P"]}]}
 * ]
 * Devolveriamos ["P"] si ruleName = 'main_type' y propName = 'values'
 *
 * @param ruleName Nombre de la regla
 * @param propName Nombre de la propiedad
 * @param rulesList Lista de reglas
 * @returns {*}
 */
const getRulePropertyValues = function (ruleName, propName, rulesList) {
    let rule = getRule(ruleName, rulesList);
    if (typeof rule == 'object') {
        for (let prop in rule) {
            if (prop == propName) {
                return rule[prop];
            }
        }
    }
    return '';
}

/**
 * Devuelve el valor booleano de la propiedad 'values' de una regla de una lista de reglas
 * Para una lista de reglas así:
 * [
 *  {"name":"related_purchase_id","operator":"equal","values":[true]},
 *  {"name":"main_type","operator":"in","values":["P"]}]}
 * ]
 * Devolveriamos true si ruleName = 'related_purchase_id'
 *
 * @param ruleName Nombre de la regla
 * @param rulesList Lista de reglas
 * @returns {boolean}
 */
const getBooleanRuleValue = function (ruleName, rulesList) {
    let values = getRulePropertyValues(ruleName, 'values', rulesList);
    if (typeof values == 'object') {
        for (let key in values) {
            return Boolean(values[key]);
        }
    }
    return false;
}

/**
 * Gestiona una regla (Crea/Modifica/Elimina) dentro de una lista de reglas
 * @param ruleName Nombre de la regla
 * @param ruleOperator Operador de la regla
 * @param ruleValues Valores de la regla
 * @param ruleParameters Parámetros de la regla
 * @param rulesList Lista de reglas
 */
const handleRule = function (ruleName, ruleOperator, ruleValues, ruleParameters, rulesList) {
    let finalRules = [];

    // Eliminamos la regla que gestionamos (si ya existe)
    let parsedRules = JSON.parse(rulesList).rules;
    for (let key in parsedRules) {
        let addRule = true;
        for (let prop in parsedRules[key]) {
            if (prop == 'name' && parsedRules[key][prop] == ruleName) {
                addRule = false;
                break;
            }
        }
        if (addRule) {
            finalRules.push(parsedRules[key]);
        }
    }

    console.log(JSON.stringify(finalRules))

    //Añadimos la nueva regla si no tiene valores vacios o false
    let addRule = true;
    if (ruleValues.length > 0) {
        for (let key in ruleValues) {
            if (!ruleValues[key]) {
                addRule = false;
                break;
            }
        }
    } else {
        addRule = false;
    }
    if (addRule) {
        let rule = {"name":ruleName, "operator":ruleOperator, "values":ruleValues};
        if (ruleParameters) {
            rule['parameters'] = ruleParameters;
        }
        finalRules.push(rule);
    }
    console.log(JSON.stringify(finalRules))
    return JSON.stringify({"rules" : finalRules});
}

export default {
    getRulePropertyValues,
    getBooleanRuleValue,
    handleRule
};